import { LayoutGrid, LineChart, Building2, Layers, Users, BookOpen, Code2, MessageSquare, Inbox } from 'lucide-react';
import { AppSidebar } from '@/components/AppSidebar';

const navGroups = [
  {
    label: 'Overview',
    items: [
      { to: '/admin/dashboard', label: 'Dashboard', icon: <LayoutGrid className="h-[18px] w-[18px]" /> },
      { to: '/admin/analytics', label: 'Analytics', icon: <LineChart className="h-[18px] w-[18px]" /> },
    ],
  },
  {
    label: 'Management',
    items: [
      { to: '/admin/orgs', label: 'Organizations', icon: <Building2 className="h-[18px] w-[18px]" /> },
      { to: '/admin/batches', label: 'Batches', icon: <Layers className="h-[18px] w-[18px]" /> },
      { to: '/admin/users', label: 'Users', icon: <Users className="h-[18px] w-[18px]" /> },
      { to: '/admin/trainer-feedback', label: 'Trainer Feedback', icon: <MessageSquare className="h-[18px] w-[18px]" /> },
      { to: '/admin/student-feedback', label: 'Student Feedback', icon: <Inbox className="h-[18px] w-[18px]" /> },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/admin/curriculum', label: 'Curriculum', icon: <BookOpen className="h-[18px] w-[18px]" /> },
      { to: '/admin/problems', label: 'Problems', icon: <Code2 className="h-[18px] w-[18px]" /> },
    ],
  },
];

const isActive = (to: string, pathname: string) =>
  pathname === to || (to !== '/admin/dashboard' && pathname.startsWith(to));

export function AdminSidebar() {
  return (
    <AppSidebar
      navGroups={navGroups}
      storageKey="admin-sidebar-collapsed"
      settingsPath="/admin/settings"
      autoCollapsePattern={/^\/admin\/curriculum\/.+/}
      isActive={isActive}
    />
  );
}
